import React, { useState, useEffect, useRef } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import CartasFinanza from './cartas';
import { formatMoneda, validaSoloNumero, validaMonto, formatoMonto, validarnumberguion } from '../../util/varios';
import moment from 'moment';
import CatalogoPlanCuenta from '../../catalogos/catalogoPlanCuenta';
import useTable from '../useTable'
import { ModalIncluirCuenta } from './modalIncluirCuentas';
import CatalogoAsientos from '../../catalogos/catalogoAsientos';


const TablaAsientosContables = () => {

  const headCells = [
    { id: 'codigo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CUENTA', textAlign: 'center' },
    { id: 'nombre', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: 'rif', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DEBE', textAlign: 'center' },
    { id: 'nrolicencia', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'HABER', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  let anio = JSON.parse(sessionStorage.getItem('anioactu'));
  let inputElement = document.getElementById('codigocuenta');
  let fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const idefiscal = JSON.parse(sessionStorage.getItem('idefiscal'));
  const accbtnastcntable = JSON.parse(sessionStorage.getItem('accbtnastcntablec'));

  const fechaTope = moment(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());


  const handleSearch = e => {
    let target = e.target;
    let st = '';
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {
            (st = x.status === '51' ? 'activo' : 'inactivo')
            if (x.idagente.includes(target.value)
              || x.nombre.toLowerCase().includes(target.value.toLowerCase())
              || x.rif.toLowerCase().includes(target.value.toLowerCase())
              || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase())
              || st.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })
  }
  const txtDebe = useRef();
  const txtHaber = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbTipoAsiento = useRef();
  const txtOrdenPago = useRef();
  const txtEgreso = useRef();
  const txtAsiento = useRef();
  const txtId = useRef();
  const txtFecha = useRef();
  const txtDescripcion = useRef();
  const cmbTipo = useRef();
  const txtDeducible = useRef();
  const chkPorcen = useRef();
  const chkMilPorcen = useRef();
  const chkUniTri = useRef();
  const chkMontFij = useRef();
  const chkOtroPor = useRef();
  const txtOtroPorcen = useRef();
  const txtIdAgente = useRef();
  const txtCuentaContable = useRef();
  const cmbNaturaleza = useRef();
  const cmbTipoPago = useRef();
  const cmbTipoRecurso = useRef();
  const [mostrar, setMostrar] = useState(false)
  const [operacion, setOperacion] = useState(0);
  const [cuentaContable, setCuentaContable] = useState()
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
  const [visibleBtn, setVisibleBtn] = useState('visible')
  const [visibleId, setVisibleId] = useState('visible')
  const [visibleOtro, setVisibleOtro] = useState('collapse')
  const [visibleISLR, setVisibleISLR] = useState('hidden')
  const [tituloHeader, setTituloHeader] = useState('Gestionar Asientos Contables.');
  const [agregar, setAgregar] = useState('')
  const [habilitado, setHabilitado] = useState(true);
  const [catalogoBene, setCatalogoBene] = useState(false);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);
  const [tercero, setTercero] = useState({
    idagente: '',
    nombre: ''
  }
  )
  const [tablaCata, setTablaCata] = useState(0);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [idmovi, setIdmovi] = useState()
  const [catalogoAsi, setCatalogoAsi] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoBene: true
  });
  const [values, setValues] = useState({
    codigocuenta: '',
    debe: '',
    descripcion: '',
    haber: '',
    idplancuenta: '',
    idcuentacontable: '',
    tipo: 0
  });

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);





  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event)
    /* setValues({...values, [inputElement.name]:maskIt('00-000-00-00-000', event.target.value)});
    txtCuentaContable.current.value = maskIt('00-000-00-00-000', event.target.value);
    */
    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57 || event.which >= 96 && event.which <= 105) {



      /* if(cod.length == 2 || cod.length == 6 || cod.length == 9 || cod.length == 12 ){
       
       num = cod.trim() + '-';
       txtCuentaContable.current.value = num;
       
     
     }
     setValues({ ...values, [event.target.name]:num}); */




      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;//alert(e.which);
  };

  const [ciudades, setCiudades] = useState();
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [operacionPer, setOperacionPer] = useState(0);



  const blanquear = () => {

    txtDebe.current.value = '';
    txtHaber.current.value = '';
    setRecords('')
    txtId.current.setAttribute("disabled", true);
    setOperacion(0)
    setTituloHeader('Gestionar Asientos Contables.');
    setVisibleISLR('hidden')
    setVisibleOtro('collapse')
    setVisibleBtn('visible')
    setVisibleId('visible')


    setValues({
      codigocuenta: '',
      debe: '',
      descripcion: '',
      haber: '',
      idplancuenta: '',
      idcuentacontable: '',
      tipo: 0
    })
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoBene: true
    });


    txtId.current.value = '';
    txtDescripcion.current.value = '';
    setActivate(false);
    setHabilitado(true);
    setHabilitadoNU(true);


  }

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/contabilidad/actualizarasiento`;

    let body;


    body = {

      operacion: ope,
      idasi: txtId.current.value !== '' ? txtId.current.value : 0,
      fec: txtFecha.current.value,
      descri: txtDescripcion.current.value.toUpperCase().trim(),
      idorden: 0,
      idefi: parseInt(idefiscal),
      rever: 0,
      idasireve: 0,
      llamado: 0,
      nTipo: parseInt(tablaCata),
      asientos: records,
      operasiento: 1
    }

    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (ope === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
        } else if (ope === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
        } else if (ope === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
        }

        blanquear()

        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro'

        }
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };


  const handleCloseSi = () => {
    setActivate(false);

    if (mensajesino.texto === 'Desea Eliminar Esta Cuenta de la Lista.') {
      let array2 = [];
      for (let i = 0; i < records.length; i++) {

        if (parseInt(records[i].idplancuenta) !== parseInt(cuentaContable.idplancuenta)) {
          array2.push(records[i]);
        }
      }
      setRecords(array2)

      let debe = 0;
      let haber = 0;

      for (let i = 0; i < array2.length; i++) {
        debe = parseFloat(debe) + parseFloat(array2[i].debe.toString())
        haber = parseFloat(haber) + parseFloat(array2[i].haber.toString())


      }

      txtDebe.current.value = formatMoneda(debe.toString().replace(',', '').replace('.', ','), ',', '.', 2);
      txtHaber.current.value = formatMoneda(haber.toString().replace(',', '').replace('.', ','), ',', '.', 2);
    } else {
      procesarRegistro();
    }

    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })



  };

  const onChange = (event) => {

    if (event.target.name === 'descripcion') {
      event.target.value = event.target.value;
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === 'unidad') {
      if (event.target.value === '4') {
        setVisibleOtro('visible')
      } else {
        setVisibleOtro('collapse')
        txtOtroPorcen.current.value = ''
      }
      setValues({ ...values, [event.target.name]: event.target.value });

    } else if (event.target.name === 'tipo') {

      setValues({ ...values, [event.target.name]: event.target.value });


    } else if (event.target.name === 'tipoasiento') {
      setTablaCata(event.target.value);
    }
    else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  }

  const cargarTabla = (values) => {
    setMostrar(false)

    let sigue = true;
    let debe = 0;
    let haber = 0;

    for (let i = 0; i < records.length; i++) {
      if (values.idplancuenta === records[i].idplancuenta) {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta Cuenta ya se encuentra Agregada.', icono: 'informacion' });
        sigue = false;
      }
    }
    if (sigue) {

      let arreglo = []

      if (parseInt(tablaCata) === 0) {
        arreglo.push({
          codigocuenta: values.codigocuenta,
          debe: values.debe,
          descripcion: values.descripcion,
          haber: values.haber,
          idplancuenta: values.idplancuenta,

        });
      } else {
        arreglo.push({
          codigocuenta: values.codigocuenta,
          debe: values.debe,
          descripcion: values.descripcion,
          haber: values.haber,
          idplancuenta: values.idplancuenta,
          idcuentacontable: values.idcuentacontable
        });
      }

      setRecords(arreglo)


    }

    for (let i = 0; i < records.length; i++) {
      debe = parseFloat(debe) + parseFloat(records[i].debe.toString())
      haber = parseFloat(haber) + parseFloat(records[i].haber.toString())


    }

    txtDebe.current.value = formatMoneda(debe.toString().replace(',', '').replace('.', ','), ',', '.', 2);
    txtHaber.current.value = formatMoneda(haber.toString().replace(',', '').replace('.', ','), ',', '.', 2);


    /*  if(tablaCata === 0){
       let endpoint = `${op.conexion}/api/contabilidad/validarcuenta?idplancuenta=${parseInt(values.idplancuenta)}`;

     
       axios.get(endpoint, {
         headers: {
           'x-access-token': `${token}`
         }
       }).then(function (response) {
         if (response.status === 200) {
           setMostrar(false)
   
           if (response.data !== '') {
 
             setActivate(false)
             setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta Cuenta ya se encuentra Aperturada.', icono: 'informacion' });
 
           } else {
             let sigue = true;
     
             for (let i = 0; i < records.length; i++) {
               if (values.idplancuenta === records[i].idplancuenta) {
                 setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta Cuenta ya se encuentra Agregada.', icono: 'informacion' });
                 sigue = false;
               }
             }
             if (sigue) {
               records.push(values);
             }
 
           setActivate(false)
           } 
 
 
         }
       
       }).catch(function (error) {
         setActivate(false);
         setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
       })
     } else {

      
       setActivate(false)

     } */



  };

  const seleccionarCuentaConta = (id) => {



    let endpoint = `${op.conexion}/api/contabilidad/ctaconta/?idcuentacontable=${id}&idefiscal=${parseInt(idefiscal)}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {

          setCuentaContable(response.data[0])
          setMostrar(true)
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const seleccionarDetalle = (id) => {


    let endpoint = `${op.conexion}/api/contabilidad/detalleasiento?idefiscal=${idefiscal}&idasiento=${parseInt(id)}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {



        if (response.data !== '') {

          let debe = 0;
          let haber = 0;

          setRecords(response.data)
          for (let i = 0; i < response.data.length; i++) {
            debe = parseFloat(debe) + parseFloat(response.data[i].debe.toString())
            haber = parseFloat(haber) + parseFloat(response.data[i].haber.toString())


          }

          txtDebe.current.value = formatMoneda(debe.toString().replace(',', '').replace('.', ','), ',', '.', 2);
          txtHaber.current.value = formatMoneda(haber.toString().replace(',', '').replace('.', ','), ',', '.', 2);

        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const seleccionarRegistro = (id) => {

    setCatalogoAsi(false);
    let campos = '*';
    let nomtab = 'asiento';
    let nomid = 'idasiento';
    let nomid2 = 'idefiscal';



    /*   let id = txtId.current.value; */
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id=${parseInt(id)}&id2=${idefiscal}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {



        if (response.data !== '') {

          setValues(response.data);
          txtId.current.value = response.data.idasiento;
          txtDescripcion.current.value = response.data.descripcion;
          cmbTipoAsiento.current.values = parseInt(response.data.tipo);
          seleccionarDetalle(response.data.idasiento);
          setTablaCata(parseInt(response.data.tipo));




        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una Cuenta Contable con este Codigo.', icono: 'informacion' });
          txtDescripcion.current.value = '';
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarPlancuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarRegistro(event.target.value);

      } else {
        setValues({
          tipo: '',
          codigocuenta: '',
          descripcion: '',
          idefiscal: '',
          cargable: '',
          naturaleza: '',
          tipopago: '',
          tiporecurso: ''
        })

      }
    }
  };

  const onCatalogoPlanCuenta = (value) => {
    setCatalogoCuenta(false);
    seleccionarRegistro(value.idplancuenta)


    if (!botones.modificar) {
      setBotones({ ...botones, catalogoBene: false });
    }
  }

  const onChangeValidar = () => {

    let sigue = true;

    if (!botones.incluir || !botones.modificar) {

      if (txtDescripcion.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la descripción del Asiento.', icono: 'informacion' });
        sigue = false;
        txtDescripcion.current.focus();

      } else if (records.length < 2) {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar al memos dos Cuentas.', icono: 'informacion' });
        sigue = false;


      } else if (parseFloat(txtDebe.current.value) !== parseFloat(txtHaber.current.value)) {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Total del Debe y el Total del Haber deben Coincidir.', icono: 'informacion' });
        sigue = false;


      }



    }
    if (sigue) {

      let msg = '';
      if (!botones.incluir) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (!botones.modificar) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (!botones.eliminar) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });


    }
  }

  const onBotones = (op) => (e) => {

    setOperacion(op)
    e.preventDefault();

    if (op === 1) {

      if (accbtnastcntable && accbtnastcntable.toString().substring(0, 1) === '1') {
        setVisibleBtn('hidden');
        setVisibleId('collapse')
        setTituloHeader('Incluir Asientos Contables.')
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoBene: false
        });
        txtDescripcion.current.removeAttribute("disabled");
        txtDescripcion.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 2) {

      if (accbtnastcntable && accbtnastcntable.toString().substring(1, 2) === '1') {
        setTituloHeader('Editar Asientos Contables.')
        txtId.current.removeAttribute("disabled");
        setVisibleBtn('hidden');
        txtId.current.focus();
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 3) {

      if (accbtnastcntable && accbtnastcntable.toString().substring(3, 4) === '1') {
        setTituloHeader('Eliminar Asientos Contables.')
        setVisibleBtn('hidden');
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 4) {

      if (accbtnastcntable && accbtnastcntable.toString().substring(2, 3) === '1') {
        setTituloHeader('Consultar Asientos Contables.')
        setVisibleBtn('hidden');
        setHabilitado(true);
        txtId.current.focus()
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn('visible');
      blanquear();
    }
  }

  const gestionarCuenta = (op, data) => (e) => {
    e.preventDefault()
    setIdmovi(data.idmovimientocontable)
    setOperacion(op)
    if (op === 1) {
      setMostrar(true)
    } else {
      seleccionarCuentaConta(data.idcuentacontable)
    }


  }

  const gestionarCuenta2 = (op, item) => (e) => {
    e.preventDefault()

    let array = [];
    let array2 = [];
    setOperacion(op)

    if (parseInt(op) === 2) {
      for (let i = 0; i < records.length; i++) {
        if (parseInt(records[i].idplancuenta) === parseInt(item.idplancuenta)) {
          setCuentaContable(records[i])
        } else {
          array2.push(records[i]);
        }
      }


      setRecords(array2)
      setMostrar(true)
    } else {

      setMensajesino({ mostrar: true, titulo: 'Notificación.', texto: 'Desea Eliminar Esta Cuenta de la Lista.', icono: 'informacion' });
      setCuentaContable(item);


    }


  }





  useEffect(() => {


  }, []);


  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div className="row col-md-12 py-5" style={{ margin: 0 }}>
        <div className='row col-md-12 py-2' style={{ margin: 0 }}>
          {/*  <div className='col-md-8 mx-auto'>
              <CartasFinanza/>
              </div> */}
          <div className='col-md-7 col-lg-7 py-3 mx-auto card shadow '>

            <div className='col-md-12 row mx-auto  rounded py-2'>
              <div className='col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between'>
                <div className='col-md-6'>

                  <h3>
                    {tituloHeader}
                  </h3>


                </div>
                <div className='col-md-3 d-flex justify-content-end'>

                  <a href='/inicio' className='text-light '><i className="fas fa-times mx-2"></i><span className='fw-bold'>Salir</span></a>

                </div>
              </div>

              <div className='row mx-auto border-azul py-3 d-flex justify-content-between rounded' style={{ fontSizeAdjust: '0.6' }}>

                <div className="p-0 col-md-12 row justify-content-between mx-auto" >
                  <div className="input-group input-group-sm mb-3 col-xl-3 col-lg-4 col-md-6 col-sm-5" style={{ visibility: visibleId }}>
                    <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO:</label>

                    <input type="text" className="form-control fs-6" ref={txtId} name='idasiento' aria-label="Sizing example input" disabled aria-describedby="inputGroup-sizing-sm" onKeyUp={validarPlancuenta} onBlur={validarPlancuenta} onChange={onChange} />
                    <button type="button" disabled={botones.catalogo} onClick={() => { setCatalogoAsi(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>

                  </div>

                  <div className="input-group input-group-sm mb-3 col-xl-3 col-lg-4 col-md-5 col-sm-5">
                    <label className="input-group-text" id="inputGroup-sizing-sm">FECHA:</label>

                    <input type="date" name='idcuentabancaria' className="form-control fs-6" ref={txtFecha} defaultValue={moment(fechasistema).format('YYYY-MM-DD')} disabled={habilitado} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                  </div>

                </div>

                <div className="input-group input-group-sm col-xl-8 col-lg-7  mb-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">DESCRIPCION:</label>
                  <input type="text" className="form-control text-uppercase rounded fs-6" ref={txtDescripcion} disabled={habilitado} name='descripcion' onChange={onChange} ></input>
                </div>
                <div className="input-group input-group-sm col-xl-4 col-lg-5 col-md-12 col-sm-12 mb-3 ">
                  <label className="input-group-text" id="inputGroup-sizing-sm">TIPO DE ASIENTO:</label>
                  <select className="form-select text-uppercase" aria-label="Default select example" name="tipo" disabled={botones.incluir} value={values.tipo.toString()} ref={cmbTipoAsiento} id="tipo" onChange={onChange}>
                    <option value="0">Apertura</option>
                    <option value="1">Movimiento</option>
                    <option value="2">Cierre</option>
                  </select>
                </div>
                <div className="p-0 col-md-12 row mx-auto justify-content-center">

                  <div className="input-group input-group-sm mx-auto mb-3 col-xl-4 col-lg-4 col-md-12">
                    <label className="input-group-text" id="inputGroup-sizing-sm">#ORDEN DE PAGO:</label>

                    <input type="text" name='idcuentabancaria' className="form-control fs-6" disabled={habilitado} ref={txtOrdenPago} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarPlancuenta} onBlur={validarPlancuenta} />

                  </div>

                  <div className="input-group input-group-sm mx-auto mb-3 col-xl-3 col-lg-3 col-md-12">
                    <label className="input-group-text" id="inputGroup-sizing-sm">#EGRESO:</label>

                    <input type="text" name='idcuentabancaria' className="form-control fs-6" disabled={habilitado} ref={txtEgreso} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarPlancuenta} onBlur={validarPlancuenta} />

                  </div>

                  <div className="input-group input-group-sm mx-auto mb-3 col-xl-5 col-lg-5 col-md-12">
                    <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO ASIENTO A REVERSAR:</label>

                    <input type="text" name='idcuentabancaria' className="form-control fs-6" disabled={habilitado} ref={txtAsiento} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarPlancuenta} onBlur={validarPlancuenta} />

                  </div>

                </div>
                <div className="col-12 p-2">
                  <div className="row col-12 d-flex justify-content-end">
                    {/*   <input type="text" className=" col-3 form-control form-control-sm rounded-pill" onChange={handleSearch} placeholder="Buscar" /> */}
                    <div className='col-3 d-flex justify-content-end'>
                      <button className="btn btn-sm btn-primary rounded-circle" disabled={!botones.consultar} onClick={gestionarCuenta(1, '')}><i className="fas fa-plus"></i> </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                  <TblContainer>
                    <TblHead />
                    <TableBody >
                      {
                        records && recordsAfterPagingAndSorting().map((item, index) => (
                          <TableRow key={index} style={{ padding: "0", fontSizeAdjust: '0.6' }}>
                            <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.codigocuenta}</TableCell>
                            <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.descripcion}</TableCell>
                            <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{formatMoneda(item.debe.replace(',', '').replace('.', ','), ',', '.', 2)}</TableCell>
                            <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{formatMoneda(item.haber.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</TableCell>

                            {!botones.incluir ?


                              <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>

                                <button onClick={gestionarCuenta2(2, item)} className={"btn btn-sm mx-1 btn-warning rounded-circle"}><i className="fa fa-edit"></i> </button>
                                <button onClick={gestionarCuenta2(3, item)} className={"btn btn-sm mx-1 btn-danger rounded-circle"}><i className="fa fa-trash"></i> </button>
                              </TableCell>

                              :

                              <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>
                                <button onClick={gestionarCuenta(4, item)} className={"btn btn-sm mx-1 btn-info rounded-circle"} ><i className="fas fa-eye"></i> </button>
                                <button onClick={gestionarCuenta(2, item)} disabled={!botones.consultar} className={"btn btn-sm mx-1 btn-warning rounded-circle"}><i className="fa fa-edit"></i> </button>
                                <button onClick={gestionarCuenta(3, item)} disabled={!botones.consultar} className={"btn btn-sm mx-1 btn-danger rounded-circle"}><i className="fa fa-trash"></i> </button>
                              </TableCell>

                            }


                          </TableRow>
                        ))
                      }
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                  <div className='col-xl-12 row justify-content-end mt-2 px-0'>
                    <div className="input-group input-group-sm mb-3 col-xl-3 col-lg-4 col-md-6 col-sm-6">
                      <label className="input-group-text" id="inputGroup-sizing-sm">Total Debe:</label>

                      <input type="text" className="form-control text-right " disabled ref={txtDebe} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                    </div>
                    <div className="input-group input-group-sm mb-3 col-xl-3 col-lg-4 col-md-6 col-sm-6">
                      <label className="input-group-text" id="inputGroup-sizing-sm">Total Haber:</label>

                      <input type="text" className="form-control text-right " disabled ref={txtHaber} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                    </div>
                  </div>
                </div>

              </div>

              <div className='col-md-12 d-flex justify-content-between mt-2'>
                {visibleBtn === 'visible' ?
                  <div className='col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start'>
                    <button disabled={botones.incluir} onClick={onBotones(1)} className="btn btn-sm mx-1 btn-primary rounded-pill" style={{ height: '27px' }} title='Incluir Plan Cuenta'><i style={{ fontSize: '9px' }} className="fas fa-plus"> Incluir </i> </button>
                    <button disabled={botones.consultar} onClick={onBotones(4)} className="btn btn-sm mx-1 btn-info rounded-pill" style={{ height: '27px' }} title='Consultar Plan Cuenta' ><i style={{ fontSize: '9px' }} className="fas fa-eye">Consultar</i> </button>
                    <button disabled={botones.modificar} onClick={onBotones(2)} className="btn btn-sm mx-1 btn-warning rounded-pill" style={{ height: '27px' }} title='Modificar Plan Cuenta'><i style={{ fontSize: '9px' }} className="fa fa-edit">Modificar</i> </button>
                    <button disabled={botones.eliminar} onClick={onBotones(3)} className="btn btn-sm mx-1 btn-danger rounded-pill" style={{ height: '27px' }} title='Eliminar Plan Cuenta'><i style={{ fontSize: '9px' }} className="fa fa-trash">Eliminar</i> </button>
                  </div> : ''

                }

                <div className='col-md-12 d-flex justify-content-end' style={{ visibility: visibleBtn === 'visible' ? 'collapse' : 'visible' }}>
                  <button disabled={botones.aceptar} onClick={onBotones(5)} ref={btnAcepta} style={{ height: '27px' }} className="mx-2 btn btn-sm rounded-pill btn-success"><i className="fas fa-check-circle" style={{ fontSize: '9px' }}>  Aceptar</i></button>
                  <button disabled={botones.cancelar} onClick={onBotones(6)} ref={btnCancela} style={{ height: '27px' }} className="mx-2 btn btn-danger btn-sm rounded-pill"><i className="fas fa-window-close" style={{ fontSize: '9px' }}> Cancelar</i></button>

                </div>
              </div>
            </div>

          </div>

        </div>
      </div >


      <ModalIncluirCuenta
        tabla={parseInt(tablaCata)}
        show={mostrar}
        onHideCancelar={() => { setMostrar(false) }}
        operacion={operacion}
        cargarTabla={cargarTabla}
        cuentaContable={cuentaContable}
        estadoboton={botones.incluir}
        idmovi={idmovi}
        asientoId={values.idasiento ? values.idasiento !== '' ? values.idasiento : 0 : 0}
        renderizar={seleccionarRegistro}

      />

      <CatalogoAsientos

        show={catalogoAsi}
        onHideCancelar={() => { setCatalogoAsi(false) }}
        onHideAceptaCatalogo={seleccionarRegistro}

      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
    </div>
  );
}
export default TablaAsientosContables;


// WEBPACK FOOTER //
// ./src/components/contabilidad/asientosContables.js